import React from 'react';

const templates = ['Wedding', 'Birthday', 'Baptism', 'Corporate', 'Other'];

function TemplateSelection({ packageData, setPackageData, errors }) {
  const handleTemplateSelection = (template) => {
    setPackageData({ ...packageData, template });
  };

  return (
    <div className="form-section">
      <div className="project-validity-options template-options">
        {templates.map((template) => (
          <div
            className={`radio-button-group ${template === 'Wedding' ? 'favorite-template' : 'hhjhh'}`}
            key={template}
          >
            <input
              type="radio"
              id={template}
              onClick={() => handleTemplateSelection(template)}
              name="type"
            />
            <label htmlFor={template}>{template}</label>
          </div>
        ))}
      </div>
      {errors.template && <p className="error-message">{errors.template}</p>}
    </div>
  );
}

export default TemplateSelection;
